
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinrajgurunagar() {



    const cardData =
    {
        keyword: 'Cab Service in Rajgurunagar',
        heading: 'Platinum24 Cabs: Cab Service in Rajgurunagar',
        headingDescription: ' Platinum24 Cabs provides trusted Cab Service in Rajgurunagar, offering convenient travel solutions for local rides, business trips, airport transfers, and outstation journeys. Our fleet of hatchbacks, sedans, SUVs, and luxury cars is well-maintained to ensure a safe and comfortable ride for individuals, families, and corporate groups. With professional drivers, punctual service, and transparent pricing, we make every journey smooth and stress-free. Whether it’s a short city commute or a long-distance trip from Rajgurunagar to major destinations, Platinum24 Cabs guarantees reliability, affordability, and complete customer satisfaction.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is Pune’s most iconic fort palace. It was once the seat of the Maratha Empire and still echoes the legacy of Bajirao and Mastani. Its mighty Delhi Gate, fountains, and expansive gardens attract thousands of visitors. Though destroyed by fire in 1828, the ruins still retain grandeur. The evening light-and-sound show recreates Maratha history. Shaniwar Wada is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it serves as a museum displaying Gandhi’s personal belongings and photographs. Its sprawling lawns and Italian arches add to the charm. It is also the resting place of Kasturba Gandhi. Aga Khan Palace is Pune’s historical gem of inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is renowned for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. The fort sits atop a hill offering trekking trails and panoramic Sahyadri views. Visitors explore its bastions, memorials, and temples reflecting Maratha valor. Monsoon adds mist, waterfalls, and greenery. Local villagers serve rustic pithla-bhakri meals. Sinhagad is Pune’s perfect mix of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, adorned with gold and ornaments, attracts lakhs of devotees annually. During Ganesh Chaturthi, the temple becomes the epicenter of grand festivities. It is also known for charitable and cultural activities. The spiritual aura here draws devotees and tourists alike. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The site features a sanctum, massive stone pillars, and a Nandi mandapa. Despite being in the city’s center, it offers peace and a spiritual retreat. Evening chants enhance the mystical ambiance. Its carvings showcase early Indian rock-cut craftsmanship. Pataleshwar is Pune’s hidden heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure trove with over 20,000 artifacts collected by Dr. Dinkar Kelkar. The collection includes ornaments, sculptures, musical instruments, and antiques of daily life. The recreated Mastani Mahal is the highlight for visitors. Students and history enthusiasts find it fascinating and educational. It preserves centuries of cultural heritage. The museum is Pune’s proud showcase of art and tradition."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop houses the Parvati Temple dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum add cultural depth. Sunrises and sunsets from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across serene gardens, it offers meditation, yoga, and personal growth workshops. Zen-inspired landscapes and modern facilities attract seekers worldwide. Visitors experience rejuvenation, peace, and mindfulness here. It is a unique blend of spirituality and modern lifestyle. Osho Ashram is Pune’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and manicured lawns. Families and couples enjoy peaceful walks, picnics, and photography here. Seasonal flowers add charm throughout the year. The garden reflects Indo-Japanese cultural ties. Pu La Deshpande Garden is Pune’s lush green paradise."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. It supplies water to the city while offering scenic landscapes. Monsoon turns it into a picturesque spot with overflowing waters. Vendors selling hot corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


     "services": [
    {
      "name": "Rajgurunagar Cab Service",
      "description": "Enjoy hassle-free travel with our Rajgurunagar Cab Service, designed to cater to daily commuters, tourists, and locals alike. Our cabs are equipped with all essential features like air conditioning, GPS, and sanitized interiors to ensure comfort and safety. Whether you’re heading to the office, a local event, or need a ride for shopping or errands, our drivers are punctual and courteous. We provide flexible scheduling and fair, transparent pricing so that you can plan your travel without worries. With 24x7 customer assistance and multiple vehicle options, your next ride in Rajgurunagar is just a call or click away."
    },
    {
      "name": "Taxi Service Rajgurunagar",
      "description": "Our Taxi Service Rajgurunagar is tailored for those who need efficient and comfortable rides across the city or to nearby locations. Featuring a fleet of clean and well-maintained vehicles, we provide transport solutions for solo travelers, groups, and families. Whether it’s for daily office commutes, hospital visits, shopping trips, or station pickups, our taxi service ensures you always reach on time. Professional drivers, GPS-enabled cars, and transparent pricing help create a dependable, customer-first travel experience you can rely on any time of day or night."
    },
    {
      "name": "Rajgurunagar Local Taxi",
      "description": "Getting around Rajgurunagar is easy with our Rajgurunagar Local Taxi service. Designed for everyday transportation, this service offers fast, safe, and affordable rides to markets, schools, offices, and other local destinations. Our drivers are familiar with every lane and landmark in the area, ensuring you take the quickest and most convenient route. With instant booking, comfortable vehicles, and affordable rates, this is the perfect choice for residents and visitors who need reliable local mobility throughout the day."
    },
    {
      "name": "Affordable Taxi Rajgurunagar",
      "description": "Our Affordable Taxi Rajgurunagar service is built for cost-conscious travelers who don’t want to compromise on comfort. Offering pocket-friendly pricing and a fleet of fuel-efficient cars, we provide daily and hourly rental plans that fit every budget. Ideal for students, employees, senior citizens, and families looking for economical transport options, this service includes flexible pickup times, courteous drivers, and zero hidden charges. Take advantage of seasonal offers and discounted packages to make every trip even more affordable."
    },
    {
      "name": "Rajgurunagar Taxi with Driver",
      "description": "Travel in comfort and confidence with our Rajgurunagar Taxi with Driver service. All our drivers are licensed, courteous, and trained in customer service and safe driving practices. This service is ideal for tourists, senior citizens, corporate professionals, or anyone who prefers the ease of being driven rather than self-driving. With flexible booking durations and a choice of vehicles ranging from hatchbacks to SUVs, you can relax and enjoy your ride while we take care of the navigation and traffic."
    },
    {
      "name": "Rajgurunagar Airport Taxi",
      "description": "Need a reliable ride to or from the airport? Our Rajgurunagar Airport Taxi service offers timely and comfortable transfers to Pune International Airport and other nearby terminals. Our professional drivers track your flight status in real-time and adjust pickup/drop schedules accordingly to avoid delays or long waits. We provide clean, spacious vehicles ideal for solo travelers, business professionals, and families with luggage. Booking is quick and easy, and our pricing is fixed with no hidden charges. Trust us to make your airport transfers smooth and stress-free."
    },
    {
      "name": "Cab Rental Rajgurunagar",
      "description": "Our Cab Rental Rajgurunagar service gives you complete control over your travel plans. Choose from hourly, daily, or weekly rental packages and a variety of car types to suit your specific needs. Whether you require a vehicle for personal errands, weddings, long drives, or corporate use, we’ve got the right solution. All our cabs are regularly maintained and sanitized, and come with options for self-drive or chauffeur-driven rides. We also provide doorstep delivery of rental cars within Rajgurunagar for added convenience."
    },
    {
      "name": "Rajgurunagar Outstation Taxi",
      "description": "Planning a trip outside Rajgurunagar? Our Rajgurunagar Outstation Taxi service is the perfect companion for weekend getaways, business trips, and intercity travel. With experienced drivers who know the highways and intercity routes well, you’ll enjoy a comfortable and secure journey. We offer sedans, SUVs, and tempo travelers for larger groups, all equipped with safety features and luggage space. Fixed pricing, fuel-inclusive packages, and on-time pickups make us the go-to choice for long-distance travel from Rajgurunagar."
    },
    {
      "name": "Rajgurunagar Corporate Taxi",
      "description": "Streamline your company’s travel with our Rajgurunagar Corporate Taxi service, trusted by businesses for employee commutes, client pickups, and event transportation. We provide a professional fleet of clean and air-conditioned cars driven by courteous, punctual drivers. GST billing, monthly invoicing, priority customer support, and customizable fleet plans are available to meet corporate requirements. Whether it’s for one-time events or recurring travel, our reliable service helps your team move smoothly and efficiently."
    },
    {
      "name": "Rajgurunagar Taxi Deals",
      "description": "Get more value for your money with our Rajgurunagar Taxi Deals, available for both local and outstation travel. We offer periodic discounts, promo codes, and special rates during weekends and festivals. Whether you're booking a one-way drop or a round-trip, our deals are designed to help you save without compromising on quality. Combine these offers with our loyalty program for even greater benefits. Keep an eye on our app and website for ongoing promotions and limited-time discounts!"
    },
    {
      "name": "Rajgurunagar City Taxi",
      "description": "Explore Rajgurunagar in comfort with our Rajgurunagar City Taxi service. Ideal for sightseeing, shopping trips, or getting around town, our taxis provide fast, affordable, and reliable transportation across the city. Our drivers are well-acquainted with local routes, traffic conditions, and tourist spots, ensuring a pleasant travel experience. Book instantly, enjoy GPS-enabled tracking, and travel in air-conditioned comfort. We also provide customized city tour packages on request for solo travelers or small groups."
    },
    {
      "name": "Rajgurunagar Family Taxi Service",
      "description": "Planning a family outing or attending a social event? Our Rajgurunagar Family Taxi Service is designed to accommodate groups of all sizes with comfort and safety. Choose from large sedans or SUVs that offer plenty of space for passengers and luggage. We prioritize your family's safety with features like child seats (on request) and experienced, polite drivers who understand the importance of smooth, stress-free travel. Affordable pricing, pre-booking options, and flexible schedules make this an ideal choice for all family travel needs."
    },
    {
      "name": "Taxi Booking Online Rajgurunagar",
      "description": "Say goodbye to waiting with Taxi Booking Online Rajgurunagar. Our intuitive platform allows you to select your pickup/drop location, preferred car type, and rental duration in just a few clicks. Enjoy the convenience of digital payments, instant confirmations, and real-time driver tracking. Whether you're at home, work, or on the go, our online booking service is available 24/7 to help you reserve your ride with ease. No calls, no queues—just fast and easy bookings at your fingertips."
    },
    {
      "name": "Rajgurunagar Taxi Service 24x7",
      "description": "Need a taxi in the middle of the night or early morning? Our Rajgurunagar Taxi Service 24x7 ensures a vehicle is always available when you need it. We provide round-the-clock service for emergencies, airport transfers, hospital visits, or anytime travel. Our support team is on standby 24/7 to assist with bookings, queries, or last-minute changes. Reliable drivers, quick response times, and clean vehicles make us the top choice for anytime, anywhere travel in Rajgurunagar."
    }
  ],
  "tableData": [
    ["Rajgurunagar Cab Service", "Taxi Service Rajgurunagar"],
    ["Rajgurunagar Local Taxi", "Affordable Taxi Rajgurunagar"],
    ["Rajgurunagar Taxi with Driver", "Rajgurunagar Airport Taxi"],
    ["Cab Rental Rajgurunagar", "Rajgurunagar Outstation Taxi"],
    ["Rajgurunagar Corporate Taxi", "Rajgurunagar Taxi Deals"],
    ["Rajgurunagar City Taxi", "Rajgurunagar Family Taxi Service"],
    ["Taxi Booking Online Rajgurunagar", "Rajgurunagar Taxi Service 24x7"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Service in Rajgurunagar",
    "WhyChoosedescription": "Platinum24 Cabs offers trusted and affordable cab services in Rajgurunagar for all types of travel needs."
  },
  {
    "WhyChooseheading": "Multiple Vehicle Options for Comfortable Travel",
    "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, and tempo travellers based on your group size and comfort preferences."
  },
  {
    "WhyChooseheading": "Clean and Sanitized Cabs for Safe Journeys",
    "WhyChoosedescription": "Our cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic travel experience in Rajgurunagar."
  },
  {
    "WhyChooseheading": "Professional Drivers with Local Route Knowledge",
    "WhyChoosedescription": "Experienced drivers familiar with Rajgurunagar and nearby areas ensure smooth and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Costs",
    "WhyChoosedescription": "We offer clear, upfront pricing that includes fuel, tolls, and driver allowances—no surprises later."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our support team is available around the clock to help with your cab bookings in Rajgurunagar."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Every Need",
    "WhyChoosedescription": "Choose from hourly, daily, or long-term rentals tailored to your travel schedule."
  },
  {
    "WhyChooseheading": "Instant Online Booking with Real-Time Confirmation",
    "WhyChoosedescription": "Book your Rajgurunagar cab easily via our website or app with secure and instant confirmation."
  }
]
















    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer cab services in Rajgurunagar?',
        answer: 'Yes, Platinum24 Cabs provides reliable and affordable cab services in Rajgurunagar for all types of travel needs.',
    },
    {
        question: 'How can I book a cab service in Rajgurunagar with Platinum24 Cabs?',
        answer: 'You can easily book your cab via our website, mobile app, or by contacting our 24x7 customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab service in Rajgurunagar?',
        answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, and luxury cars to suit different requirements.',
    },
    {
        question: 'Can I book a cab in Rajgurunagar for both local and outstation travel?',
        answer: 'Yes, Platinum24 Cabs offers cab services for local travel within Rajgurunagar as well as outstation trips.',
    },
    {
        question: 'Are the drivers experienced and familiar with Rajgurunagar routes?',
        answer: 'Absolutely, our drivers are professional, licensed, and have good knowledge of Rajgurunagar and nearby routes.',
    },
    {
        question: 'Is hourly and daily cab service available in Rajgurunagar?',
        answer: 'Yes, we offer flexible hourly and daily cab rental packages based on your travel schedule.',
    },
    {
        question: 'Are safety and hygiene protocols followed for cabs in Rajgurunagar?',
        answer: 'Yes, all our vehicles are regularly sanitized, and drivers follow strict safety and hygiene protocols.',
    },
    {
        question: 'Is cab service in Rajgurunagar available 24x7?',
        answer: 'Yes, Platinum24 Cabs provides round-the-clock cab services and bookings in Rajgurunagar.',
    },
    {
        question: 'What payment methods are accepted for cab service in Rajgurunagar?',
        answer: 'We accept cash, UPI, digital wallets, and card payments for your convenience.',
    },
    {
        question: 'Can I choose custom pickup and drop-off points in Rajgurunagar?',
        answer: 'Yes, you can specify your preferred pickup and drop-off locations anywhere within Rajgurunagar.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Nilesh Gawade',
        feedback: 'Platinum24 Cabs offers excellent cab service in Rajgurunagar. On-time, clean vehicle, and polite driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Prajakta Joshi',
        feedback: 'Very professional and comfortable cab service in Rajgurunagar. Will book again for sure!',
        rating: 5,
    },
];






































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];













    return (
        <div>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/86.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinrajgurunagar;